<template>
  <div id="betInAcceptance">
    <div
      id="betInAcceptanceContainer"
      v-if="getAcceptingBets != null && getAcceptingBets.length > 0"
    >
      <v-card
        class="cart"
        v-for="(bet, index) in getAcceptingBets"
        elevation="1"
        :key="'acceptingBets_' + index"
      >
        <div class="cart-header">
          <span>{{ $t('acceptanceBet') }}</span>
        </div>
        <div class="cart-content">
          <div class="row">
            <div class="col-xl-12 container-info">
              <div class="col-xl-8 code-bet-acceptance-info bet-code">
                {{ bet.code }}
              </div>
              <div class="col-xl-4 code-bet-acceptance-info">
                <div class="container-pending-revived-icons">
                  <div class="circle-pending-revived"></div>
                  <div class="circle-pending-revived"></div>
                  <div class="circle-pending-revived"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cart-content">
          <span>
            <span class="text-capitalize">{{ $t('status') }} </span>:
            <span class="status-info">{{ $t('pending') }}</span>
          </span>
        </div>
      </v-card>
    </div>
    <div
      id="betAcceptedContainer"
      v-if="getAcceptedBets != null && getAcceptedBets.length > 0"
    >
      <v-card
        v-for="(bet, index) in getAcceptedBets"
        class="cart"
        elevation="1"
        :key="'acceptedBets_' + index"
      >
        <div class="cart-header">
          <span>{{ $t('acceptanceBet') }}</span>
        </div>
        <div class="cart-content">
          <div class="row">
            <div class="col-xl-12 container-info">
              <div class="col-xl-12 code-bet-acceptance-info bet-code">
                {{ bet.code }}
              </div>
            </div>
          </div>
        </div>

        <div class="cart-content">
          <span>
            <span class="text-capitalize">{{ $t('status') }}:</span>
            <span class="status-info">
              <v-icon dense>mdi-checkbox-marked-circle</v-icon>
              {{ $t('betAccepted') }}
            </span>
          </span>
        </div>

        <div class="cart-content">
          <div class="row">
            <div class="col-xl-12 container-info">
              <!--                            <div class="col-xl-8 code-bet-acceptance-info">-->
              <!--                            </div>-->
              <div class="col-xl-8 code-bet-acceptance-info">
                <v-btn color="white" text @click="sendPrintMessage(bet)">
                  {{ $t('print') }}
                </v-btn>
              </div>
              <div class="col-xl-4 code-bet-acceptance-info">
                <v-btn
                  color="white"
                  text
                  @click="removeBetFromAcceptedBets(bet.code)"
                >
                  {{ $t('close') }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>

    <div
      id="betAcceptedWithChangeContainer"
      v-if="
        getAcceptedBetWithChange != null && getAcceptedBetWithChange.length > 0
      "
    >
      <v-card
        v-for="(bet, index) in getAcceptedBetWithChange"
        class="cart"
        elevation="1"
        :key="'acceptedBetWithChange_' + index"
      >
        <div class="cart-header">
          <span>{{ $t('acceptanceBet') }}</span>
        </div>
        <div class="cart-content">
          <div class="row">
            <div class="col-xl-12 container-info">
              <div class="col-xl-8 code-bet-acceptance-info bet-code">
                {{ bet.code }}
              </div>
              <div class="col-xl-4 code-bet-acceptance-info">
                <div class="container-pending-revived-icons">
                  <div class="circle-pending-revived"></div>
                  <div class="circle-pending-revived"></div>
                  <div class="circle-pending-revived"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cart-content">
          <span>
            <span class="text-capitalize"
              >{{ $t('proposalChangeAmount') }}:</span
            >
          </span>
        </div>

        <div class="cart-content">
          <span>
            <span class="text-capitalize"
              >{{ $t('amount') }}: {{ bet.amount_real }}</span
            >
          </span>
        </div>

        <div class="cart-content">
          <span>
            <span class="text-capitalize"
              >{{ $t('potentialWinnings') }}: {{ bet.winning_total }}</span
            >
          </span>
        </div>

        <div class="cart-content">
          <div class="row">
            <div class="col-xl-12 container-info">
              <div class="col-xl-6 code-bet-acceptance-info">
                <div
                  class="button-review button-review-thumb-up"
                  style="margin: 0px !important"
                  @click="acceptBetReview(bet.code)"
                >
                  <span class="content-button-review">
                    <v-icon large>mdi-thumb-up</v-icon>
                    <span class="label-review">{{ $t('accept') }}</span>
                  </span>
                </div>
              </div>
              <div class="col-xl-6 code-bet-acceptance-info">
                <div
                  class="button-review button-review-thumb-down"
                  style="margin: 0px !important"
                  @click="rejectBetReview(bet.code)"
                >
                  <span class="content-button-review">
                    <v-icon large>mdi-thumb-down</v-icon>
                    <span class="label-review">{{ $t('reject') }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>

    <div
      id="betRejectedContainer"
      v-if="getRejectedBets != null && getRejectedBets.length > 0"
    >
      <v-card
        v-for="(bet, index) in getRejectedBets"
        class="cart"
        elevation="1"
        :key="'rejectedBets_' + index"
      >
        <div class="cart-header">
          <span>{{ $t('acceptanceBet') }}</span>
        </div>
        <div class="cart-content">
          <div class="row">
            <div class="col-xl-12 container-info">
              <div class="col-xl-8 code-bet-acceptance-info bet-code">
                {{ bet.code }}
              </div>
              <div class="col-xl-4 code-bet-acceptance-info"></div>
            </div>
          </div>
        </div>

        <div class="cart-content">
          <span>
            <span class="text-capitalize">{{ $t('status') }}:</span>
            <span class="status-info">
              <v-icon dense>mdi-checkbox-marked-circle</v-icon>
              {{ $t('betWasNotAccepted') }}
            </span>
          </span>
        </div>

        <div class="cart-content">
          <div class="row">
            <div class="col-xl-12 container-info">
              <div class="col-xl-8 code-bet-acceptance-info"></div>
              <div class="col-xl-4 code-bet-acceptance-info">
                <v-btn
                  color="white"
                  text
                  @click="removeBetFromRejectedBets(bet.code)"
                >
                  {{ $t('close') }}
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </div>
    <v-dialog
      transition="dialog-top-transition"
      max-width="700"
      v-model="showModalBetReview"
      content-class="modal-on-top"
    >
      <v-card class="text-center pt-6 pb-6">
        <v-col cols="12">
          <v-icon x-large @click="closeDialogBetReview()"
            >mdi-close-circle</v-icon
          >
        </v-col>
        <v-col cols="12" class="message-bet-success">
          <span class="ml-2 text-uppercase">{{ messageModalBetReview }}</span
          ><br />
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BetInAcceptance',
  components: {},
  data: () => ({
    showModalBetReview: false,
    messageModalBetReview: '',
  }),
  computed: {
    ...mapGetters({
      getAcceptingBets: 'cart/getAcceptingBets',
      getAcceptedBets: 'cart/getAcceptedBets',
      getAcceptedBetWithChange: 'cart/getAcceptedBetWithChange',
      getRejectedBets: 'cart/getRejectedBets',
    }),
  },
  methods: {
    ...mapActions({
      removeBetFromAcceptedBets: 'cart/removeBetFromAcceptedBets',
      removeBetFromRejectedBets: 'cart/removeBetFromRejectedBets',
      sendReviewBet: 'cart/sendReviewBet' /* deprecated */,
      removeBetFromAcceptedWithChange: 'cart/removeBetFromAcceptedWithChange',
      acceptsRevisedBet: 'cart/acceptsRevisedBet',
      rejectRevisedBet: 'cart/rejectRevisedBet',
    }),
    async acceptBetReview(betCode) {
      const vm = this
      /*const result = await this.sendReviewBet({'code': betCode, 'mode': 'accept'});*/
      const result = await this.acceptsRevisedBet({ code: betCode })

      if (result == null) {
        this.messageModalBetReview = vm.$t('Something went wrong!')
        this.showModalBetReview = true
        return
      }

      if (result.data.result) {
        this.messageModalBetReview = vm.$t('betRevivedAccepted')
        this.showModalBetReview = true
      } else {
        this.messageModalBetReview = vm.$t('Something went wrong!')
        this.showModalBetReview = true
      }
      this.removeBetFromAcceptedWithChange(betCode)
    },
    async rejectBetReview(betCode) {
      const vm = this
      /*const result = await this.sendReviewBet({'code': betCode, 'mode': 'reject'});*/
      const result = await this.rejectRevisedBet({ code: betCode })

      if (result == null) {
        this.messageModalBetReview = vm.$t('Something went wrong!')
        this.showModalBetReview = true
        return
      }

      if (result.data.result) {
        this.messageModalBetReview = vm.$t('betRevivedNotAccepted')
        this.showModalBetReview = true
      } else {
        this.messageModalBetReview = vm.$t('Something went wrong!')
        this.showModalBetReview = true
      }
      this.removeBetFromAcceptedWithChange(betCode)
    },
    closeDialogBetReview() {
      this.showModalBetReview = false
      this.messageModalBetReview = ''
    },
    sendPrintMessage(bet) {
      this.$root.$emit('print_this_bet', bet)
    },
  },
  mounted() {
    // console.log('mounted component BetInAcceptance')
  },
}
</script>
